module.exports = __webpack_public_path__ + "static/media/5-10.60af9bf4.mp3";